import styled from 'styled-components'

export const StyledSuppliersListItem = styled.div`
  height:50px;

  .header-item {
    flex: 1;
    width: 100%;
  }

  .header-new-item {
    flex: 1;
    width: 100%;
    color: var(--color-contrast-brand);
  }

  .itens-menu {
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    padding-left: 15px;
    cursor: pointer;
    height: 50px;
    width: 100%;

    &-actions {
      display: flex;
    }
  }
`

export const HeaderItem = styled.div`
  .header-item {
    flex: 1;
    width: 100%;
  }

  .header-new-item {
    flex: 1;
    width: 100%;
    color: var(--color-contrast-brand);
  }
`